import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { FaCookieBite } from 'react-icons/fa';

const CookieConsent = () => {
  const { t } = useTranslation();
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem('cookieConsent')) {
      const timer = setTimeout(() => setShow(true), 1000);
      return () => clearTimeout(timer);
    }
  }, []);

  if (!show) return null;

  return (
    <div className="cookie-consent">
      <div className="cookie-content">
        <div className="cookie-icon"><FaCookieBite /></div>
        <div className="cookie-text">
          <p>
            {t('cookies.message')} <a href="/privacy">{t('cookies.policy')}</a>.
          </p>
        </div>
        <div className="cookie-buttons">
          <button className="btn-cookie-accept" onClick={() => { localStorage.setItem('cookieConsent', 'accepted'); setShow(false); }}>
            {t('cookies.accept')}
          </button>
          <button className="btn-cookie-decline" onClick={() => { localStorage.setItem('cookieConsent', 'declined'); setShow(false); }}>
            {t('cookies.decline')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
